<template>

  <div class="search-bar">
    <el-form inline>

      <el-form-item>
        <label class="form-label">{{ $t('ApplyAfterSales.processingProgress') }}</label>
        <el-select class="custom-select-width" v-model="processProgress"
                   :placeholder="$t('ApplyAfterSales.processingProgressPlaceholder') "
                   clearable>
          <el-option :label="$t('ApplyAfterSales.unprocessed')" value="0"></el-option>
          <el-option :label="$t('ApplyAfterSales.processing')" value="1"></el-option>
          <el-option :label="$t('ApplyAfterSales.completed')" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-item-button" style="margin-top: 36px;">
        <el-button class="button-background-color" @click="search"> {{ $t('ApplyAfterSales.search') }}</el-button>
        <el-button @click="reset" class="custom-reset-button">{{ $t('ApplyAfterSales.reset') }}</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>


<script>
import {ref, getCurrentInstance} from 'vue';
import {useI18n} from 'vue-i18n';
import {ElSelect, ElOption, ElButton} from 'element-plus';

export default {
  components: {
    ElSelect,
    ElOption,
    ElButton,
  },
  setup() {
    const { t } = useI18n();
    
    const submitProgress = ref('');
    const processProgress = ref('');
    
    const instance = getCurrentInstance();
    const emit = instance?.emit;
    
    const search = () => {
      const payload = {};

      if (submitProgress.value || submitProgress.value === '0') {
        payload["commit_status-eq"] = submitProgress.value;
      }

      if (processProgress.value || processProgress.value === '0') {
        payload["process_status-eq"] = processProgress.value;
      }

       emit('search', payload);
    };

    const reset = () => {
      submitProgress.value = '';
      processProgress.value = '';

      search();
    };

    return {
      submitProgress,
      processProgress,
      search,
      reset,
      t
    };
  },
};
</script>
<style scoped>
.search-bar {
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
  margin-left: 24px;

  border: 1px solid rgb(236, 239, 239);
  background-color: rgb(255, 255, 255);
  border-radius: 2px;
  margin-right: 20px;
  padding: 16px 24px 5px 24px;
}

/* 对于小屏幕 */
@media (max-width: 600px) {
  .custom-select-width {
    width: 100%; /* 小屏幕上全宽 */
    margin-right: -15px;
    margin-left: 0;
    min-width: 300px; /* 或者你希望的最小宽度 */
  }
}

/* 对于中等屏幕 */
@media (min-width: 601px) and (max-width: 1024px) {
  .custom-select-width {
    width: 100%; /* 中等屏幕上半宽 */
    margin-right: -15px;
    margin-left: 0;
    min-width: 300px; /* 或者你希望的最小宽度 */
  }
}

/* 对于大屏幕 */
@media (min-width: 1025px) {
  .custom-select-width {
    width: 100%; /* 中等屏幕上半宽 */
    min-width: 300px; /* 或者你希望的最小宽度 */
    margin-right: -15px;
    margin-left: 0;
  }
}

</style>
  